<template>
     <div>
      <h1>{{ $t('help.ISAUnlockPatternHelp_title') }}</h1>
      <p class="text-justify">
          {{ $('Visual login shortcut (min 3 dots). You can reset the pattern by clicking on the Info icon in the the upper right corner of the screen.')}}
      </p>
      
    </div>
</template>

<script>

export default  {
  components: {    
  },  
  data() {
    return {      
    }
  },
  watch : {    
  },    
  methods: {        
    },
  mounted() {            
  },
  name: "ISAHelpModalContent"
}
</script>

<style lang="scss" scoped>
h1 {
  font-weight: 700;
}

.modal-title {
  font-weight: 700;
}

</style>
